<div class="login-page">
  <div class="logo-wrapper">
    <img class="login-back-image" src="assets/logo.png" />
  </div>
  <div class="login-message" *ngIf="user">
    <span>{{ 'static.welcomemsg' | translate }}</span> &nbsp; <span class="user">{{ user }} !</span>
  </div>
  <div class="login-error" *ngIf="errorText">
    <span>{{ errorText | translate }}</span>
  </div>
  <ion-button fill="clear" *ngIf="user" class="login-button" (click)="loginClicked()" color="primary">
    <span>{{ 'static.login.start' | translate }}</span>
  </ion-button>
</div>
